import './RequirementList.css'; 

// Updated JSX component to work with your backend data structure
const RequirementList = ({ buttonLabel, responsibilities, label, description, updateResponsibility, removeResponsibility, addResponsibility }) => {

    return (
        <div className="form-group">
        <label>{label}</label>
        <p className="field-description">{description}</p>
        
        <div className="create-responsibilities-list">
          {responsibilities.map((responsibility, index) => (
            <div key={index} className="create-responsibility-item">
              <span className="bullet">•</span>
              <input
                type="text"
                placeholder={`Enter ${label}`}
                value={responsibility}
                onChange={(e) => updateResponsibility(index, e.target.value)}
                className="create-responsibility-input"
              />
              {responsibilities.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeResponsibility(index)}
                  className="remove-btn"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
        
        <button
          type="button"
          onClick={addResponsibility}
          className="add-responsibility-btn"
        >
          {buttonLabel}
        </button>
        
        <div className="char-count">
          Total characters: {responsibilities.join('').length} / 500
        </div>
      </div>
    );
  };
  
  export default RequirementList;